var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-spin-container"},[_c('Spin',{attrs:{"fix":"","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }